import CommandsPool from "@kaspernj/api-maker/build/commands-pool"

const setLayout = (layout) => {
  CommandsPool.current().globalRequestData.layout = layout
}

export default setLayout
